import localStorageStore from "./localStorageStore"; // Import your localStorage facade

interface UserStore {
  language: string;
  userId: string | null;
  userName: string;
  landingPage: string;
  keepCredentials: boolean;
  setToken: (token: string) => void;
  setLanguage: (language: string) => void;
  setUserId: (userId: string) => void;
  setUserName: (userName: string) => void;
  setLandingPage: (landingPage: string) => void;
  setKeepCredentials: (keepCredentials: boolean) => void;
}

const getFlagOrDefault = (key: string, defaultValue: boolean): boolean => {
  const value = localStorageStore.getItem(key);
  if (value === "true") return true;
  if (value === "false") return false;
  return defaultValue;
};

export const readUserSession = (): UserStore => {
  const setToken = (token: string) => {
    localStorageStore.setItem("token", token);
  };

  const setLanguage = (language: string) => {
    localStorageStore.setItem("language", language);
  };

  const setUserId = (userId: string) => {
    localStorageStore.setItem("userId", userId);
  };

  const setUserName = (userName: string) => {
    localStorageStore.setItem("userName", userName);
  };

  const setLandingPage = (landingPage: string) => {
    localStorageStore.setItem("landingPage", landingPage);
  };

  const setKeepCredentials = (keepCredentials: boolean) => {
    localStorageStore.setItem(
      "keepCredentials",
      JSON.stringify(keepCredentials)
    );
  };

  return {
    language: localStorageStore.getItem("language") || "",
    userId: localStorageStore.getItem("userId") || "",
    userName: localStorageStore.getItem("userName") || "",
    landingPage: localStorageStore.getItem("landingPage") || "/",
    keepCredentials: getFlagOrDefault("keepCredentials", true),
    setToken,
    setLanguage,
    setUserId,
    setUserName,
    setLandingPage,
    setKeepCredentials,
  };
};

const useUserStore = readUserSession;

export default useUserStore;
